import type { ConsumerStepId } from '../lib/steps';
import { useCoverageSelection } from './use-coverage-selection';

/** The plan's headline numbers: what insurance is projected to pay and what's left to the consumer. */
export function usePlanTotals(clientId: string) {
  const selection = useCoverageSelection(clientId);
  const { scenario, selectedProjection } = selection;
  const hasInsurance = !!selectedProjection;

  const totalCareCost = hasInsurance ? selectedProjection.totalCareCost : (scenario?.totalCost ?? 0);
  const projectedPayout = hasInsurance ? selectedProjection.projectedPayout : 0;
  const outOfPocket = hasInsurance ? selectedProjection.outOfPocket : totalCareCost;
  // The whole-event summary needs a month-by-month projection; without one the plan review stands in.
  const summaryStep: ConsumerStepId =
    hasInsurance && selectedProjection.projection ? 'walkthrough-summary' : 'review';

  return { ...selection, hasInsurance, totalCareCost, projectedPayout, outOfPocket, summaryStep };
}
